import styled from '@emotion/styled';
import { fit, Reveal, Segment } from '@landsbankinn/ui';
import React from 'react';
import { Prismic } from './Prismic';

interface IProps {
  html: string;
  type?: 'inline' | 'block';
  ar?: number;
  noSpace?: boolean;
}

const Host = styled.div<{ noSpace?: boolean }>`
  margin: ${(props) => (props.noSpace ? '0' : '40px 0')};
  overflow: hidden;
`;

const Wrapper = styled(Reveal)<{ ar: number }>`
  display: block;

  position: relative;
  z-index: 0;

  &::before {
    content: '';
    display: block;
    padding-bottom: ${(props) => `calc(${props.ar} * 100%)`};
  }

  input {
    background-color: red !important;
  }

  > div > * {
    ${fit}
    display: block;

    width: 100%;
    height: 100%;

    pointer-events: auto;
  }
`;

export function getRichTextEmbedHtml(embed: Prismic.RichText) {
  let html = (embed as any)[0]?.oembed?.html;

  // infogram oembed
  if (html?.match(/infogram-embed/)) {
    const [, id] = html.match(/data-id="(.*?)"/);
    const [, title] = html.match(/data-title="(.*?)"/);
    html = `<iframe src="https://e.infogram.com/${id}?src=embed" title="${title}" width="100%" height="100%" scrolling="no" frameborder="0" style="border:none;" allowfullscreen="allowfullscreen"></iframe>`;
  }

  // Use as URL value
  try {
    const value = Prismic.text(embed);
    if (value?.match(/https?:\/\//)) {
      html = `<iframe src="${value}" width="100%" height="654" scrolling="no" frameborder="0" style="border:none;" allowfullscreen="allowfullscreen"></iframe>`;
    }
  } catch (err) {}

  return html;
}

export const Embed = ({ html, type, ar = 9 / 16, noSpace }: IProps) => {
  const content = <div dangerouslySetInnerHTML={{ __html: html }} />;

  if (type === 'inline') {
    return (
      <Host noSpace={noSpace}>
        <Wrapper ar={ar}>{content}</Wrapper>
      </Host>
    );
  }

  return (
    <Segment>
      <Wrapper ar={ar}>{content}</Wrapper>
    </Segment>
  );
};
